import React from "react";

import classes from "./RadioButton.module.scss";
import { IOption } from "../Input/Input";
import RadioButtonOption from "./RadioButtonOption/RadioButtonOption";

interface IProps {
  value: string;
  onChange: (value: string) => void;
  options: IOption[] | undefined;
  disabled?: boolean;
  invalid?: boolean;
  className?: string;
}

const RadioButton: React.FC<IProps> = ({ value, onChange, options, disabled, invalid, className }) => {
  const classNames = [classes.OptionContainer];
  if (className) {
    classNames.push(className);
  }
  return (
    <div className={classNames.join(' ')}>
      {options &&
        options.map((option) => (
          <RadioButtonOption
            key={option.value}
            value={option.value}
            label={option.label}
            labelTranslation={option.labelTranslation}
            isActive={option.value === value}
            onClick={onChange}
            disabled={disabled}
            invalid={invalid}
          />
        ))}
    </div>
  );
};

export default RadioButton;
